import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./PaymentFailed.css";

function PaymentFailed() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <section className="payment-failed-page">
        <div className="payment-failed-card">
          <div className="failed-icon">!</div>

          <h1>Payment Failed</h1>

          <p>
            Your payment could not be completed. Please try again or choose
            another payment method.
          </p>

          <div className="failed-actions">
            <button onClick={() => navigate("/checkout")}>
              Try Again
            </button>

            <button
              className="go-cart-btn"
              onClick={() => navigate("/cart")}
            >
              Back To Cart
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default PaymentFailed;